type ToastType = 'info' | 'success' | 'error';

export function showToast(message: string, type: ToastType = 'info', duration = 4500): void {
  const container = document.getElementById('toast-root');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.setAttribute('role', type === 'error' ? 'alert' : 'status');
  toast.textContent = message;
  container.appendChild(toast);

  requestAnimationFrame(() => toast.classList.add('show'));
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

export function renderToastContainer(): string {
  return '<div class="toast-container" aria-live="polite" aria-atomic="true"></div>';
}